import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=2cfddc30&"
import script from "./AddGoods.vue?vue&type=script&lang=js&"
export * from "./AddGoods.vue?vue&type=script&lang=js&"
import style0 from "./AddGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports